import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/departments";

// Fetch Departments
export const fetchDepartments = createAsyncThunk("departments/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  return response.data;
});

// Add Department
export const addDepartment = createAsyncThunk("departments/add", async (departmentData) => {
  const response = await hrmsPostRequest(API_URL, departmentData);
  return response.data;
});

// Update Department
export const updateDepartment = createAsyncThunk("departments/update", async ({ id, updatedData }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
  return response.data;
});

// Delete Department
export const deleteDepartment = createAsyncThunk("departments/delete", async (id) => {
  await hrmsDeleteRequest(`${API_URL}/${id}`);
  return id;
});

// Toggle Department Status
export const toggleDepartmentStatus = createAsyncThunk("departments/toggleStatus", async (id) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}/toggle`, {});
  return response.data;
});

const departmentSlice = createSlice({
  name: "departments",
  initialState: {
    departments: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDepartments.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDepartments.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.departments = action.payload;
      })
      .addCase(fetchDepartments.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addDepartment.fulfilled, (state, action) => {
        state.departments.push(action.payload);
      })
      .addCase(updateDepartment.fulfilled, (state, action) => {
        const index = state.departments.findIndex((dept) => dept.id === action.payload.id);
        if (index !== -1) {
          state.departments[index] = action.payload;
        }
      })
      .addCase(deleteDepartment.fulfilled, (state, action) => {
        state.departments = state.departments.filter((dept) => dept.id !== action.payload);
      })
      .addCase(toggleDepartmentStatus.fulfilled, (state, action) => {
        const index = state.departments.findIndex((dept) => dept.id === action.payload.id);
        if (index !== -1) {
          state.departments[index] = action.payload;
        }
      });
  },
});

export default departmentSlice.reducer;